import { useState } from 'preact/hooks';

export function HandoffPrompt({
  busy,
  error,
  available,
  onSubmit
}: {
  busy: boolean;
  error?: boolean;
  // Whether a live agent is online right now. Drives the copy so we never imply
  // a live connection when the request will actually become an email follow-up.
  available: boolean;
  onSubmit: (email: string) => void;
}) {
  const [email, setEmail] = useState('');
  const valid = /.+@.+\..+/.test(email.trim());
  return (
    <div class="handoff">
      <div class="handoff-label">
        {available
          ? "What's the best email to reach you? We'll connect you with our team now."
          : "Our team is offline right now — leave your email and we'll reply by email, usually within one business day."}
      </div>
      <div class="handoff-row">
        <input
          type="email"
          value={email}
          placeholder="you@example.com"
          aria-label="Email"
          onInput={(e) => setEmail((e.target as HTMLInputElement).value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && valid && !busy) onSubmit(email.trim());
          }}
        />
        <button
          class="handoff-submit"
          disabled={!valid || busy}
          onClick={() => onSubmit(email.trim())}
        >
          {busy ? '…' : available ? 'Connect' : 'Send'}
        </button>
      </div>
      {error && <div class="handoff-error">Something went wrong. Please try again.</div>}
    </div>
  );
}
